import { Routes } from '@angular/router';
import { AuthGuard } from './core/auth.guard';
import { PlatformAdminGuard } from './core/guards/platform-admin.guard';
import { tenantGuard } from './core/guards/tenant.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./chatbot-whatsapp/chatbot-whatsapp.component').then(m => m.ChatbotWhatsappComponent),
    data: {
      title: 'Chatbot Pezeta | Chatbot WhatsApp con IA para Empresas',
      description: 'Automatiza tu atención al cliente con Chatbot Pezeta. Planes desde $999 MXN/mes. IA avanzada, CRM integrado, soporte mexicano.',
      canonical: 'https://chatbot.pezetasolutions.com'
    }
  },
  {
    path: 'inicio',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'servicios',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'nosotros',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'contacto',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'testimonios',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'chatbot-whatsapp',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'politicas-de-privacidad',
    loadComponent: () => import('./privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent),
    data: {
      title: 'Política de Privacidad | Pezeta Solutions',
      description: 'Política de privacidad de Pezeta Solutions. Conoce cómo protegemos y manejamos tus datos personales.',
      canonical: 'https://chatbot.pezetasolutions.com/politicas-de-privacidad'
    }
  },
  {
    path: 'terminos-y-condiciones',
    loadComponent: () => import('./terms-and-conditions/terms-and-conditions.component').then(m => m.TermsAndConditionsComponent),
    data: {
      title: 'Términos y Condiciones | Pezeta Solutions',
      description: 'Términos y condiciones de uso de Chatbot Pezeta. Plataforma SaaS de chatbot con IA integrada a WhatsApp Business API. Pezeta Solutions.',
      canonical: 'https://chatbot.pezetasolutions.com/terminos-y-condiciones'
    }
  },
  {
    path: 'eliminacion-de-datos',
    loadComponent: () => import('./data-deletion/data-deletion.component').then(m => m.DataDeletionComponent),
    data: {
      title: 'Eliminación de Datos del Usuario | Pezeta Solutions',
      description: 'Solicita la eliminación de tus datos personales almacenados en Chatbot Pezeta. Proceso claro, plazo máximo de 30 días. Pezeta Solutions.',
      canonical: 'https://chatbot.pezetasolutions.com/eliminacion-de-datos'
    }
  },
  {
    path: 'blogs',
    children: [
      {
        path: '',
        loadComponent: () => import('./blogs/blogs-list.component').then(m => m.BlogsListComponent),
        data: {
          title: 'Blog de Desarrollo de Software y Automatización | Pezeta Solutions',
          description: 'Artículos sobre desarrollo de software personalizado, automatización de procesos, sistemas ERP y transformación digital para empresas mexicanas.',
          canonical: 'https://chatbot.pezetasolutions.com/blogs'
        }
      },
      {
        path: 'automatizacion-procesos-administrativos',
        loadComponent: () => import('./blogs/process-automation-blog.component').then(m => m.ProcessAutomationBlogComponent),
        data: {
          title: 'Cómo la automatización puede ahorrarte horas al día en procesos administrativos | Blog Pezeta Solutions',
          description: 'Descubre cómo automatizar tareas repetitivas en tu empresa puede ahorrar tiempo, reducir errores y aumentar la productividad sin grandes inversiones. Guía completa para PyMEs mexicanas.',
          canonical: 'https://chatbot.pezetasolutions.com/blogs/automatizacion-procesos-administrativos'
        }
      },
      {
        path: 'chatbot-whatsapp-para-vender-mas',
        loadComponent: () => import('./blogs/whatsapp-chatbot-blog.component').then(m => m.WhatsAppChatbotBlogComponent),
        data: {
          title: '¿Qué es un chatbot para WhatsApp y cómo puede ayudarte a vender más? | Blog Pezeta Solutions',
          description: 'Descubre cómo automatizar WhatsApp con un chatbot puede aumentar tus ventas, mejorar la atención al cliente y ahorrar tiempo en tu empresa. Guía completa para PyMEs mexicanas.',
          canonical: 'https://chatbot.pezetasolutions.com/blogs/chatbot-whatsapp-para-vender-mas'
        }
      }
    ]
  },
  {
    path: 'partners',
    loadComponent: () => import('./partners/partners.component').then(m => m.PartnersComponent),
    data: {
      title: 'Programa de Comisionistas | ChatbotPezeta',
      description: 'Únete como vendedor comisionista y gana hasta 25% del primer mes + 10% recurrente vendiendo ChatbotPezeta.',
      canonical: 'https://chatbot.pezetasolutions.com/partners'
    }
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
    data: {
      title: 'Acceso al Sistema ERP | Pezeta Solutions',
      description: 'Accede a tu sistema ERP personalizado de Pezeta Solutions. Portal seguro para empresas.',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: 'login/:slug',
    loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
    data: {
      title: 'Acceso al Sistema',
      description: 'Accede a tu sistema. Portal seguro para empresas.',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
    data: {
      title: 'Recuperar Contraseña | Pezeta Solutions ERP',
      description: 'Recupera tu contraseña del sistema ERP de Pezeta Solutions.',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
    data: {
      title: 'Restablecer Contraseña | Pezeta Solutions ERP',
      description: 'Restablece tu contraseña del sistema ERP de Pezeta Solutions.',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: 'accept-invitation/:token',
    loadComponent: () => import('./accept-invitation/accept-invitation.component').then(m => m.AcceptInvitationComponent),
    data: {
      title: 'Aceptar Invitación | Pezeta Solutions ERP',
      description: 'Acepta tu invitación y crea tu cuenta en el sistema ERP.',
      robots: 'noindex, nofollow'
    }
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./dashboard/overview/overview.component').then(m => m.OverviewComponent)
      },
      {
        path: 'departments',
        canActivate: [tenantGuard, AuthGuard],
        loadComponent: () => import('./dashboard/departments/departments.component').then(m => m.DepartmentsComponent),
        data: { requiredPermission: 'manageDepartments' },
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/departments/list/list.component').then(m => m.DepartmentsListComponent)
          },
          {
            path: 'create',
            loadComponent: () => import('./dashboard/departments/create/create.component').then(m => m.CreateDepartmentComponent)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./dashboard/departments/edit/edit.component').then(m => m.EditDepartmentComponent)
          },
          {
            path: 'detail/:id',
            loadComponent: () => import('./dashboard/departments/detail/detail.component').then(m => m.DepartmentDetailComponent)
          }
        ]
      },
      {
        path: 'positions',
        canActivate: [tenantGuard, AuthGuard],
        loadComponent: () => import('./dashboard/positions/positions.component').then(m => m.PositionsComponent),
        data: { requiredPermission: 'managePositions' },
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/positions/list/list.component').then(m => m.PositionsListComponent)
          },
          {
            path: 'create',
            loadComponent: () => import('./dashboard/positions/create/create.component').then(m => m.CreatePositionComponent)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./dashboard/positions/edit/edit.component').then(m => m.EditPositionComponent)
          },
          {
            path: 'detail/:id',
            loadComponent: () => import('./dashboard/positions/detail/detail.component').then(m => m.PositionDetailComponent)
          }
        ]
      },
      {
        path: 'employees',
        canActivate: [tenantGuard, AuthGuard],
        loadComponent: () => import('./dashboard/employees/employees.component').then(m => m.EmployeesComponent),
        data: { requiredPermission: 'manageEmployees' },
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/employees/list/list.component').then(m => m.EmployeesListComponent)
          },
          {
            path: 'create',
            loadComponent: () => import('./dashboard/employees/create/create.component').then(m => m.CreateEmployeeComponent)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./dashboard/employees/edit/edit.component').then(m => m.EditEmployeeComponent)
          },
          {
            path: 'detail/:id',
            loadComponent: () => import('./dashboard/employees/detail/detail.component').then(m => m.EmployeeDetailComponent)
          },
          {
            path: 'organization-chart',
            loadComponent: () => import('./dashboard/employees/organization-chart/organization-chart.component').then(m => m.OrganizationChartComponent)
          }
        ]
      },
      {
        path: 'conversations',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/conversations/conversations.component').then(m => m.ConversationsComponent)
      },
      {
        path: 'ai-metrics',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/ai-metrics/ai-metrics.component').then(m => m.AIMetricsComponent)
      },
      {
        path: 'prompt-trainer',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/prompt-trainer/prompt-trainer.component').then(m => m.PromptTrainerComponent)
      },
      // {
      //   path: 'satisfaction-surveys',
      //   canActivate: [tenantGuard],
      //   loadComponent: () => import('./dashboard/satisfaction-surveys/satisfaction-surveys.component').then(m => m.SatisfactionSurveysComponent)
      // },
      {
        path: 'leads',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/leads/leads.component').then(m => m.LeadsComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/leads/list/list.component').then(m => m.LeadsListComponent)
          },
          {
            path: 'create',
            loadComponent: () => import('./dashboard/leads/create/create.component').then(m => m.CreateLeadComponent)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./dashboard/leads/edit/edit.component').then(m => m.EditLeadComponent)
          },
          {
            path: 'detail/:id',
            loadComponent: () => import('./dashboard/leads/detail/detail.component').then(m => m.LeadDetailComponent)
          }
        ]
      },
      {
        path: 'opportunities',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/opportunities/opportunities.component').then(m => m.OpportunitiesComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/opportunities/list/list.component').then(m => m.OpportunityListComponent)
          },
          {
            path: 'create',
            loadComponent: () => import('./dashboard/opportunities/create/create.component').then(m => m.OpportunityCreateComponent)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./dashboard/opportunities/edit/edit.component').then(m => m.OpportunityEditComponent)
          },
          {
            path: 'detail/:id',
            loadComponent: () => import('./dashboard/opportunities/detail/detail.component').then(m => m.OpportunityDetailComponent)
          }
        ]
      },
      {
        path: 'accounts',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/accounts/accounts.component').then(m => m.AccountsComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/accounts/list/list.component').then(m => m.AccountsListComponent)
          },
          {
            path: 'create',
            loadComponent: () => import('./dashboard/accounts/create/create.component').then(m => m.AccountCreateComponent)
          },
          {
            path: ':id/edit',
            loadComponent: () => import('./dashboard/accounts/edit/edit.component').then(m => m.AccountEditComponent)
          },
          {
            path: ':id',
            loadComponent: () => import('./dashboard/accounts/detail/detail.component').then(m => m.AccountDetailComponent)
          }
        ]
      },
      {
        path: 'contacts',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/contacts/contacts.component').then(m => m.ContactsComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/contacts/list/list.component').then(m => m.ContactsListComponent)
          },
          {
            path: 'create',
            loadComponent: () => import('./dashboard/contacts/create/create.component').then(m => m.ContactCreateComponent)
          },
          {
            path: ':id/edit',
            loadComponent: () => import('./dashboard/contacts/edit/edit.component').then(m => m.ContactEditComponent)
          },
          {
            path: ':id',
            loadComponent: () => import('./dashboard/contacts/detail/detail.component').then(m => m.ContactDetailComponent)
          }
        ]
      },
      {
        path: 'gallery',
        canActivate: [tenantGuard, AuthGuard],
        loadComponent: () => import('./dashboard/gallery/gallery.component').then(m => m.GalleryComponent),
        data: { requiredPermission: 'manageGallery' },
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/gallery/list/list.component').then(m => m.GalleryListComponent)
          },
          {
            path: 'create',
            loadComponent: () => import('./dashboard/gallery/create/create.component').then(m => m.GalleryCreateComponent)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./dashboard/gallery/edit/edit.component').then(m => m.GalleryEditComponent)
          },
          {
            path: 'detail/:id',
            loadComponent: () => import('./dashboard/gallery/detail/detail.component').then(m => m.GalleryDetailComponent)
          }
        ]
      },
      {
        path: 'appointments',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/appointments/appointments.component').then(m => m.AppointmentsComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/appointments/list/list.component').then(m => m.AppointmentsListComponent)
          },
          {
            path: 'create',
            loadComponent: () => import('./dashboard/appointments/create/create.component').then(m => m.CreateAppointmentComponent)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./dashboard/appointments/edit/edit.component').then(m => m.EditAppointmentComponent)
          },
          {
            path: 'detail/:id',
            loadComponent: () => import('./dashboard/appointments/detail/detail.component').then(m => m.AppointmentDetailComponent)
          }
        ]
      },
      {
        path: 'release-notes',
        loadComponent: () => import('./dashboard/release-notes/release-notes.component').then(m => m.ReleaseNotesComponent)
      },
      // {
      //   path: 'audit',
      //   loadComponent: () => import('./dashboard/audit/audit.component').then(m => m.AuditComponent)
      // },
      // {
      //   path: 'backups',
      //   loadComponent: () => import('./dashboard/data-backups/backups.component').then(m => m.BackupsComponent)
      // },
      {
        path: 'profile',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/profile/profile.component').then(m => m.ProfileComponent)
      },
      {
        path: 'scheduling/assignment',
        canActivate: [tenantGuard, AuthGuard],
        data: { requiredPermission: 'manageChatbot' },
        loadComponent: () => import('./dashboard/scheduling/assignment/assignment.component').then(m => m.SchedulingAssignmentComponent)
      },
      {
        path: 'scheduling/business-hours',
        canActivate: [tenantGuard, AuthGuard],
        data: { requiredPermission: 'manageChatbot' },
        loadComponent: () => import('./dashboard/scheduling/business-hours/business-hours.component').then(m => m.SchedulingBusinessHoursComponent)
      },
      {
        path: 'scheduling/reminders',
        canActivate: [tenantGuard, AuthGuard],
        data: { requiredPermission: 'manageChatbot' },
        loadComponent: () => import('./dashboard/scheduling/reminders/reminders.component').then(m => m.SchedulingRemindersComponent)
      },
      {
        path: 'conversation-summaries',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/conversation-summaries-router/conversation-summaries-router.component').then(m => m.ConversationSummariesRouterComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/conversation-summaries-list/conversation-summaries-list.component').then(m => m.ConversationSummariesListComponent)
          },
          {
            path: 'detail/:id',
            loadComponent: () => import('./dashboard/conversation-summaries/detail/detail.component').then(m => m.ConversationSummaryDetailComponent)
          }
        ]
      },
      {
        path: 'users',
        canActivate: [AuthGuard],
        loadComponent: () => import('./dashboard/users/users.component').then(m => m.UsersComponent),
        data: { requiredPermission: 'manageUsers' },
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/users/list/list.component').then(m => m.UsersListComponent)
          },
          {
            path: 'create',
            loadComponent: () => import('./dashboard/users/create/create.component').then(m => m.CreateUserComponent)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./dashboard/users/edit/edit.component').then(m => m.EditUserComponent)
          },
          {
            path: 'detail/:id',
            loadComponent: () => import('./dashboard/users/detail/detail.component').then(m => m.UserDetailComponent)
          }
        ]
      },
      {
        path: 'roles',
        canActivate: [AuthGuard],
        loadComponent: () => import('./dashboard/roles/roles.component').then(m => m.RolesComponent),
        data: { requiredPermission: 'manageRoles' },
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/roles/list/list.component').then(m => m.RolesListComponent)
          },
          {
            path: 'create',
            loadComponent: () => import('./dashboard/roles/create/create.component').then(m => m.CreateRoleComponent)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./dashboard/roles/edit/edit.component').then(m => m.EditRoleComponent)
          },
          {
            path: 'detail/:id',
            loadComponent: () => import('./dashboard/roles/detail/detail.component').then(m => m.RoleDetailComponent)
          },
          {
            path: 'permissions/:id',
            loadComponent: () => import('./dashboard/roles/permissions/permissions.component').then(m => m.RolePermissionsComponent)
          }
        ]
      },
      {
        path: 'system-settings',
        loadComponent: () =>
          import('./dashboard/system-settings/system-settings.component')
            .then(m => m.SystemSettingsComponent),
        data: {}
      },
      {
        path: 'tenant-settings',
        canActivate: [tenantGuard],
        loadComponent: () =>
          import('./dashboard/tenant-settings/tenant-settings.component')
            .then(m => m.TenantSettingsComponent),
        data: {}
      },
      {
        path: 'whatsapp-setup',
        canActivate: [tenantGuard],
        loadComponent: () =>
          import('./dashboard/whatsapp-setup/whatsapp-setup.component')
            .then(m => m.WhatsAppSetupComponent),
        data: {}
      },
      {
        path: 'products',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/products/products.component').then(m => m.ProductsComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/products/list/list.component').then(m => m.ProductsListComponent)
          },
          {
            path: 'create',
            loadComponent: () => import('./dashboard/products/create/create.component').then(m => m.CreateProductComponent)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./dashboard/products/edit/edit.component').then(m => m.EditProductComponent)
          },
          {
            path: 'detail/:id',
            loadComponent: () => import('./dashboard/products/detail/detail.component').then(m => m.ProductDetailComponent)
          }
        ]
      },
      {
        path: 'product-brands',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/product-brands/product-brands.component').then(m => m.ProductBrandsComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/product-brands/list/list.component').then(m => m.ProductBrandsListComponent)
          },
          {
            path: 'create',
            loadComponent: () => import('./dashboard/product-brands/create/create.component').then(m => m.CreateProductBrandComponent)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./dashboard/product-brands/edit/edit.component').then(m => m.EditProductBrandComponent)
          }
        ]
      },
      {
        path: 'product-categories',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/product-categories/product-categories.component').then(m => m.ProductCategoriesComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/product-categories/list/list.component').then(m => m.ProductCategoriesListComponent)
          },
          {
            path: 'create',
            loadComponent: () => import('./dashboard/product-categories/create/create.component').then(m => m.CreateProductCategoryComponent)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./dashboard/product-categories/edit/edit.component').then(m => m.EditProductCategoryComponent)
          }
        ]
      },
      {
        path: 'product-subcategories',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/product-subcategories/product-subcategories.component').then(m => m.ProductSubcategoriesComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/product-subcategories/list/list.component').then(m => m.ProductSubcategoriesListComponent)
          },
          {
            path: 'create',
            loadComponent: () => import('./dashboard/product-subcategories/create/create.component').then(m => m.CreateProductSubcategoryComponent)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./dashboard/product-subcategories/edit/edit.component').then(m => m.EditProductSubcategoryComponent)
          }
        ]
      },
      {
        path: 'remarketing/templates',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/remarketing/remarketing.component').then(m => m.RemarketingComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/remarketing/templates/template-list/template-list.component').then(m => m.TemplateListComponent)
          },
          {
            path: 'create',
            loadComponent: () => import('./dashboard/remarketing/templates/template-form/template-form.component').then(m => m.TemplateFormComponent)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./dashboard/remarketing/templates/template-form/template-form.component').then(m => m.TemplateFormComponent)
          },
          {
            path: 'detail/:id',
            loadComponent: () => import('./dashboard/remarketing/templates/template-detail/template-detail.component').then(m => m.TemplateDetailComponent)
          }
        ]
      },
      {
        path: 'remarketing/audiences',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/remarketing/remarketing.component').then(m => m.RemarketingComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/remarketing/audiences/list/audience-list.component').then(m => m.AudienceListComponent)
          },
          {
            path: 'create',
            loadComponent: () => import('./dashboard/remarketing/audiences/form/audience-form.component').then(m => m.AudienceFormComponent)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./dashboard/remarketing/audiences/form/audience-form.component').then(m => m.AudienceFormComponent)
          },
          {
            path: 'detail/:id',
            loadComponent: () => import('./dashboard/remarketing/audiences/detail/audience-detail.component').then(m => m.AudienceDetailComponent)
          }
        ]
      },
      {
        path: 'remarketing/consents',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/remarketing/consents/consents.component').then(m => m.ConsentsComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/remarketing/consents/list/consent-list.component').then(m => m.ConsentListComponent)
          }
        ]
      },
      {
        path: 'remarketing/campaigns',
        canActivate: [tenantGuard],
        loadComponent: () => import('./dashboard/remarketing/campaigns/campaigns.component').then(m => m.CampaignsComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/remarketing/campaigns/list/campaign-list.component').then(m => m.CampaignListComponent)
          },
          {
            path: 'new',
            loadComponent: () => import('./dashboard/remarketing/campaigns/form/campaign-form.component').then(m => m.CampaignFormComponent)
          },
          {
            path: ':id',
            loadComponent: () => import('./dashboard/remarketing/campaigns/detail/campaign-detail.component').then(m => m.CampaignDetailComponent)
          },
          {
            path: ':id/edit',
            loadComponent: () => import('./dashboard/remarketing/campaigns/form/campaign-form.component').then(m => m.CampaignFormComponent)
          }
        ]
      },
      {
        path: 'webhooks',
        loadComponent: () => import('./dashboard/webhooks/webhooks.component').then(m => m.WebhooksComponent),
        children: [
          {
            path: '',
            loadComponent: () => import('./dashboard/webhooks/webhook-list/webhook-list.component').then(m => m.WebhookListComponent)
          },
          {
            path: 'new',
            loadComponent: () => import('./dashboard/webhooks/webhook-form/webhook-form.component').then(m => m.WebhookFormComponent)
          },
          {
            path: ':id',
            loadComponent: () => import('./dashboard/webhooks/webhook-history/webhook-history.component').then(m => m.WebhookHistoryComponent)
          },
          {
            path: ':id/edit',
            loadComponent: () => import('./dashboard/webhooks/webhook-form/webhook-form.component').then(m => m.WebhookFormComponent)
          },
          {
            path: ':id/history',
            loadComponent: () => import('./dashboard/webhooks/webhook-history/webhook-history.component').then(m => m.WebhookHistoryComponent)
          }
        ]
      },
      {
        path: 'platform-admin/tenants',
        canActivate: [PlatformAdminGuard],
        loadComponent: () => import('./platform-admin/tenants-list/tenants-list.component').then(m => m.TenantsListComponent),
        data: {
          title: 'Gestión de Tenants | Platform Admin',
          robots: 'noindex, nofollow'
        }
      }
    ]
  },
  {
    path: '**',
    loadComponent: () => import('./not-found/not-found.component').then(m => m.NotFoundComponent),
    data: {
      title: 'Página No Encontrada - 404 | Pezeta Solutions',
      description: 'La página que buscas no existe. Regresa al inicio de Pezeta Solutions.',
      robots: 'noindex, nofollow'
    }
  }
];